import RadioCardListPage from "@components/RadioCardListPage"
import { isHairstyleFlow, isHomeDesignFlow } from "@helpers/localStorage"

const HAIRSTYLE_OPTIONS = [
  { emoji: "✨", key: "hairVolume" },
  { emoji: "💇", key: "hairstyle" },
  { emoji: "🎨", key: "hairColor" },
  { emoji: "🌀", key: "hairTexture" },
  { emoji: "💫", key: "overall" },
]

const DEFAULT_OPTIONS = [
  { emoji: "✨", key: "skin" },
  { emoji: "💇", key: "hairstyle" },
  { emoji: "👁️", key: "features" },
  { emoji: "👗", key: "fashion" },
  { emoji: "🌟", key: "overall" },
]

const HOME_OPTIONS = [
  { emoji: "🛋️", key: "livingRoom" },
  { emoji: "🛏️", key: "bedroom" },
  { emoji: "🍳", key: "kitchen" },
  { emoji: "💼", key: "homeOffice" },
  { emoji: "🏠", key: "overallVibe" },
]

function getOptions() {
  if (isHairstyleFlow()) return HAIRSTYLE_OPTIONS
  if (isHomeDesignFlow()) return HOME_OPTIONS
  return DEFAULT_OPTIONS
}

function getTranslationKey() {
  if (isHomeDesignFlow()) return "confidenceBoostHomeDesign"
  return "confidenceBoost"
}

export default function ConfidenceBoostPage() {
  return (
    <RadioCardListPage
      translationKey={getTranslationKey()}
      options={getOptions()}
    />
  )
}
